module.exports = __webpack_public_path__ + "static/media/Tooltip.0da07d02.svg";